//
//
//
//
//
//
//
//
//

import { dig } from '@/utils/lodash'
import {
  isBool,
  isFunction,
} from '@/utils/validator'
import CDropdownItem from '../CDropdownItem'

export default {
  name: 'CSmartDropdownItem',

  components: { CDropdownItem },

  inheritAttrs: false,

  props: {
    apiMethod: Function,

    params: {
      type: Object,
      default: () => ({}),
    },

    valueName: {
      type: String,
      default: 'wid',
    },

    hasAllOption: {
      type: [
        Boolean,
        String,
      ],
    },

    dataPath: {
      type: String,
      default: 'data',
    },

    labelField: {
      type: String,
      default: 'name',
    },

    dataHook: { type: Function },

    list: {
      type: Array,
      default: () => [],
    },

    labelName: {
      type: String,
      default: 'value',
    },

    labelFormatter: {
      type: String,
      default: '{name}',
    },
  },

  data () {
    return {
      iOptions: [],
      originalList: [],
    }
  },

  created () {
    this.setList()
  },

  methods: {
    async normalize (list = []) {
      if (isFunction(this.dataHook)) {
        list = await this.dataHook(list)
      }

      list = list.map((item) => {
        return {
          value: item[this.valueName],
          text: item[this.labelName] || this.labelFormatter.replace(/{[a-zA-Z]+}/g, (key) => item[key.replace(/[{}]/g, '')]) || '',
        }
      })

      if (this.hasAllOption) {
        const text = isBool(this.hasAllOption) ? '所有' : this.hasAllOption

        list.unshift({
          value: null,
          text,
        })
      }

      return list
    },

    async setList () {
      let list = this.list

      if (!list.length && isFunction(this.apiMethod)) {
        const result = await this.apiMethod(this.params)

        if (!result.err) {
          list = dig(result, this.dataPath)
          this.originalList = list
        }
      }

      list = await this.normalize(list)
      this.iOptions = list
    },
  },

}
